import { defineStore } from 'pinia';

export const useDeferCourseFormStore = defineStore('deferCourseFormStore', () => { 
    var isDeferCourseOptionSelected = ref<boolean>(false);  
    var _enrolment = ref<IEnrolment>();  
    var deferType = ref<string>("defer");

    const getDeferBtnClicked = computed(
        () => {
            return isDeferCourseOptionSelected.value;
        }
    ); 

    function setDeferBtnClicked(abortBtnClicked: boolean) {
        isDeferCourseOptionSelected.value = abortBtnClicked;
    } 

    function setEnrolment(enrolment: IEnrolment) {
        _enrolment.value = enrolment;
    }    

    function setDeferType(type: string) {
        deferType.value = type;
    } 
    
    const getEnrolment = computed(() => _enrolment.value);
    const getdeferType = computed(() => deferType.value);
    return {   
        getDeferBtnClicked: getDeferBtnClicked, 
        getEnrolment: getEnrolment, 
        setDeferBtnClicked: setDeferBtnClicked,
        setEnrolment: setEnrolment,
        setDeferType:setDeferType,
        getdeferType:getdeferType
    }
});